export enum IntercomCustomAttributeKey {
    AppName = 'Digiloop app name',
    StoreDomain = 'Store Domain',
    Uninstalled = 'Uninstalled',
    SubscriptionPlanName = 'Subscription plan name',
    Subscription = 'Subscription',
    Trial = 'Trial',
    ShopifyPlan = 'Shopify plan',
    Providers = 'Providers',
    HomeDelivery = 'Home delivery',
    PickupPoint = 'Pickup point',
    ThirdPartyFulfillment = 'Fulfillment service',
}
